<template>
  <article>
    <div class="container">
      <HeroesMainHero
        v-if="hero && (hero.title?.value || hero.body?.value)"
        :main-hero="{
          intro: {
            icon: hero.icon ?? null,
            title: hero.title ?? null,
            body: hero.body ?? null,
          },
          img: hero.image,
          article: hero.links,
        }" />
      <section class="vecozo-content content-block-mid">
        <h1 v-if="title" v-bind="useEpiAttrs(title)">{{ title.value }}</h1>
        <BlocksWerkenbijContentArea v-if="body" :content="body" />
      </section>
      <aside class="vacancy__aside content-block-side">
        <BlocksWerkenbijContentArea v-if="rightColumn?.value?.content" :content="rightColumn" />
      </aside>
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { ContentResponseModel, WerkenbijContentPageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { body, hero, rightColumn, title } = props.data.content as WerkenbijContentPageResponseModel;
</script>

<style lang="scss" scoped>
.vecozo-content {
  grid-row: 2 / 3;

  &.content-block-mid {
    padding-bottom: px(60);
  }
}

.vacancy {
  &__aside {
    grid-row: 4 / 5;

    > .btn {
      display: none;
    }

    @include media-breakpoint-up(xl) {
      grid-row: 2 / 3;

      > .btn {
        display: inline-flex;
      }
    }
  }
}
</style>
